import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActionService {

  constructor(private httpClientService: HttpClientService) { }

  async createActions(
    requestTaskId: number,
    title: string,
    kindId: number,
    priority: number,
    status: number,
    responsiblePersonId?: number,
    personId?: number,
    startDate?: Date,
    endDate?: Date,
    description?: string) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Action
    }, {
      startActionDate: startDate,
      finishActionDate: endDate,
      personId: personId,
      title: title,
      description: description,
      kindId: kindId,
      priority: priority,
      status: status,
      responsiblePersonId: responsiblePersonId,
      requestTaskId: requestTaskId
    });
    return await firstValueFrom(observable);
  }

  async updateAction(
    id:number,
    title: string,
    kindId: number,
    priority: number,
    status: number,
    responsiblePersonId?: number,
    personId?: number,
    description?: string) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Action
    }, {
      id:id,
      personId: personId,
      title: title,
      description: description,
      kindId: kindId,
      priority: priority,
      status: status,
      responsiblePersonId: responsiblePersonId,
    });
    return await firstValueFrom(observable);
  }

  async getByIdAction(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Action
    },id);
    return await firstValueFrom(observable);
  }

  async getUserByIdAction(userId){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Action,
      action:"GetUserByIdActions"
    },userId);
    return await firstValueFrom(observable);
  }
}
